// extracted by mini-css-extract-plugin
module.exports = {"u-hide-tablet":"_25M_fXMd7DohDTQvzPhowm","u-show-tablet":"_1ZjCclcL7VVDCw6ZvcvRAA","u-show-tablet-inline":"_2oqcbYnanJm59TU5Bg5dDj","pie-chart":"_20lsq4ruI68eQhYulgIAUx"};